export const DEFAULT_USER_PROFILE_IMAGE = { fileName: '', image: '' };
